export default [
    'Curves提供一個暫時性的置物空間給有需要之會員，不負任何實際保管責任，若有遺失由使用者自行負責，因此貴重物品請勿置放於置物櫃內。',
    '置物櫃內不得存放違禁品及有公共危險疑慮之物品。',
    '若遺失置物櫃鑰匙者，由Curves重新打鑰匙，費用則由租用者自行負擔。',
    '辦理會籍終止時，請務必一同辦理置物櫃退租作業。',
];
